import React, { useState } from 'react'
import { useHistory } from 'react-router-dom';
import '../index.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReCAPTCHA from "react-google-recaptcha";
import { toBeRequired } from '@testing-library/jest-dom/dist/matchers';

toast.configure()
function LoginForm() {
    const [details, setDetails] = useState({email:""});
    const [detailss, setDetailss] = useState({token:"",password:""});
    const history = useHistory();
    const recap = false;
    const [nome,setNome]=useState('dfd');
    const [changepass
        ,setchangepass
    ]=useState(null);
    
    const [error, setError] = useState(null);
    const Login = details => {
        fetch(`${localStorage.getItem('url')}/web/password_reset/`, {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(details)
        }).then(data => {
            if (!data.ok) {
                throw Error('Dados de acesso invalidos');
            }
            return data.json();
        }
        ).then(data => {
            toast.success(`Enviado com Sucesso`);
setNome(null)
setchangepass("sdsdds");
        }).catch(e => {
            setError(e.message);
            toast.error(`O email nao esta associado a nenhum usuario!`);


        }
        )

    }
    const Change_pass = detailss => {
        fetch(`${localStorage.getItem('url')}/web/password_reset/confirm/`, {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(detailss)
        }).then(data => {
            if (!data.ok) {
                throw Error('Dados de acesso invalidos');
            }
            return data.json();
        }
        ).then(data => {
            toast.success(`Password redefinida com sucesso`);
            history.push("/");
        }).catch(e => {
            setError(e.message);
            toast.error(`Token ou password invalida!`);


        }
        )

    }
    
    const submitHandler = e => {
        e.preventDefault();
        Login(details);

    }
    const change_handler=e=>{
        e.preventDefault();
        console.log(detailss)
        Change_pass(detailss);
    }
    const onChange = (value) => {
        console.log("Captcha value:", value);
        recap=!recap;
    }
    return (
        <form className="login" onSubmit={submitHandler} >
             <div className="form-inner">
             {nome && <div>
                <img src={require('./images/ENHS.png')} />
                
                <div className="form-group">
                    <label htmFor="email">Email</label>
                    <input type="email" name="username" id="username" onChange={e => setDetails({ ...details, email: e.target.value })} value={details.email} placeholder="Email para qual deseja mudar a Password" />

                </div>
                <div className='recap'>
                    <ReCAPTCHA
                        sitekey="6LdkkSQhAAAAAOf_RZJC95aDbaqNpHFRF5yOydq6"
                        onChange={onChange} />

                </div>
                <input  type="submit"  id = "Geeks" name="myGeeks" value="Enviar" disabled={recap}/>


                <div>
                    <div className="form-group">
                        <label>MAPI 2022</label>

                    </div>
                </div>
</div>
}
{changepass && <div>
    <div className="form-group">
                    <label htmFor="text">Token</label>
                    <input type="text" name="username"  onChange={e => setDetailss({ ...detailss, token: e.target.value })} value={detailss.token} placeholder="Auth Token" />

    </div>
    
    <div className="form-group">
                    <label htmFor="password">Password</label>
                    <input type="password" name="username"  onChange={e => setDetailss({ ...detailss, password: e.target.value })} value={detailss.password} />

                </div>

                <div className='recap'>
                    <ReCAPTCHA
                        sitekey="6LdkkSQhAAAAAOf_RZJC95aDbaqNpHFRF5yOydq6"
                        onChange={onChange} />

                </div>
                <button onClick={change_handler}>Confirmar </button>


                <div>
                    <div className="form-group">
                        <label>MAPI 2022</label>

                    </div>
                </div>
</div>

}

            </div>
             </form>
    )
}

export default LoginForm
